var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "message-details-container",
        attrs: { "element-loading-text": "Loading..." },
      },
      [
        _vm.messageInfo && _vm.status === 1
          ? _c("el-card", { attrs: { shadow: "never" } }, [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("i", {
                      staticClass: "msg-icon",
                      class: [_vm.messageInfo.Type],
                    }),
                    _vm._v(" From: "),
                    _c("strong", [_vm._v(_vm._s(_vm.messageInfo.SEName))]),
                  ]),
                  _c("span", { staticClass: "datetime" }, [
                    _vm._v(_vm._s(_vm.messageInfo.CreatedOn)),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "card-body", class: [_vm.messageInfo.Type] },
                [
                  _vm.messageInfo.Type === "image"
                    ? [
                        _c(
                          "el-image",
                          {
                            attrs: {
                              src: _vm.messageInfo.Url,
                              "preview-src-list": [_vm.messageInfo.Url],
                              fit: "contain",
                              "z-index": 9999,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                attrs: { slot: "placeholder" },
                                slot: "placeholder",
                              },
                              [
                                _vm._v(" Loading "),
                                _c("span", { staticClass: "dot" }, [
                                  _vm._v("..."),
                                ]),
                              ]
                            ),
                            _c("div", {
                              staticClass: "error-image-slot",
                              attrs: { slot: "error" },
                              slot: "error",
                            }),
                          ]
                        ),
                      ]
                    : _vm.messageInfo.Type === "video"
                    ? [
                        _c("video", {
                          attrs: {
                            src: _vm.messageInfo.Url,
                            poster: _vm.messageInfo.Poster,
                            controlslist: "nodownload",
                            controls: "",
                          },
                        }),
                      ]
                    : _vm.messageInfo.Type === "voice"
                    ? [
                        _c("VoicePlayer", {
                          attrs: { src: _vm.messageInfo.Url },
                        }),
                      ]
                    : _vm.messageInfo.Type === "text"
                    ? [_vm._v(_vm._s(_vm.messageInfo.Message))]
                    : _vm.messageInfo.Type === "link"
                    ? [
                        _c(
                          "el-link",
                          {
                            staticClass: "link",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.goTo(_vm.messageInfo)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.messageInfo.Message) + " ")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ])
          : !_vm.messageInfo && _vm.status === 0
          ? _c(
              "div",
              { staticClass: "tips-wrapper" },
              [
                _c("el-result", {
                  attrs: {
                    icon: "info",
                    subTitle: "The message does not exist or has been deleted.",
                  },
                }),
              ],
              1
            )
          : !_vm.loading && _vm.status === -2
          ? _c(
              "div",
              { staticClass: "tips-wrapper" },
              [
                _c("el-result", {
                  attrs: {
                    icon: "error",
                    subTitle:
                      "Loading failed, please check the network and try again",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }